<script setup>

import {useFormField} from "../../../Registration/composables/useFormField";
import FieldErrorMessage from "../../../Registration/components/Fields/FieldErrorMessage.vue";

const emit = defineEmits(['blur', 'input']);

const {item, group, groupId, backend} = defineProps(['item', 'group', 'groupId', 'backend']);
const {model, uniqueItemId, path, inputAttributes, isReadOnly, getFieldClasses, createBlurHandler, createInputHandler} = useFormField(item, group, groupId, (v) => v, (v) => v, backend);

const handleBlur = createBlurHandler(emit);
const handleInput = createInputHandler(emit);

const className = getFieldClasses('form-item-input text-field');
</script>

<template>
    <div :class="className">
        <label :for="uniqueItemId">
            {{ item.label }}
            <span v-if="item.required && !isReadOnly"> *</span>
        </label>
        <input
            :id="uniqueItemId"
            type="number"
            v-model="model"
            class="form-item form-element"
            v-bind="inputAttributes"
            :step="item.render_type === 'decimal' ? 'any' : '1'"
            :inputmode="item.render_type === 'decimal' ? 'decimal' : 'numeric'"
            :pattern="item.render_type === 'decimal' ? '[0-9]*[.,]?[0-9]*' : '\\d*'"
            @keydown="(e) => {
               if (isReadOnly) return;
               if (item.render_type !== 'decimal') {
                   const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
                   if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
                       e.preventDefault();
                   }
               }
           }"
            @paste="(e) => {
               if (isReadOnly) return;
               if (item.render_type !== 'decimal') {
                   const pasted = (e.clipboardData || window.clipboardData).getData('text');
                   if (!/^\d+$/.test(pasted)) {
                       e.preventDefault();
                   }
               }
           }"
            @blur="handleBlur"
            @input="handleInput"
        />
        <FieldErrorMessage :path="path" :backend="backend" />
    </div>
</template>

<style scoped>
.is-readonly input {
    opacity: 0.5;
    pointer-events: none;
    background-color: #f8f9fa;
    cursor: not-allowed;
}
</style>
